export class EduChatUser {
    _id: string;
    name: string;
    email: string;
    phone: string;
    message: string;
}